<template>
  <vx-card
    id="loading-indirect-indicator"
    class="vs-con-loading__container w-full pointer"
    @click="handleClick"
  >
    <vs-row vs-type="flex">
      <vs-col vs-type="flex" vs-justify="center" vs-lg="1" vs-sm="1" vs-xs="1">
        <feather-icon icon="UserPlusIcon" class="colorBoxI mr-2 mt-1" />
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="start"
        vs-lg="6"
        vs-sm="6"
        vs-xs="6"
        class="ml-4 mt-4"
      >
        {{ $t('indirect_required') | capitalize }}
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="end"
        vs-lg="4"
        vs-sm="4"
        vs-xs="4"
        class="mt-3"
      >
        <span class="card-value" :style="{ color: countColor }">
          {{ this.indirectCount }}/{{ this.indirectDays
          }}{{ $t('days') | capitalize }}
        </span>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
import dashboard from '@/http/requests/dashboard'
export default {
  props: {
    refresh: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: 'indirect-indicator',
      loading: false,
      indirectCount: 0,
      indirectDays: 0,
      countColor: '',
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
    getData() {
      this.loading = true
      dashboard
        .indirectCard()
        .then((res) => {
          this.indirectCount = res.data.data.vacancies
          this.indirectDays = res.data.data.aging
          this.countColor = '#05A85C'
          if (this.indirectDays >= 15) this.countColor = '#FAA700'
          if (this.indirectDays >= 30) this.countColor = '#F2353C'
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },
  },
  mounted() {
    this.getData()
    if (this.refresh === true) {
      var v = this
      setInterval(function () {
        v.getData()
      }, process.env.VUE_APP_CHART_RELOAD_TIME)
    }
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading({
          container: `#loading-${this.name}`,
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close(`#loading-${this.name} > .con-vs-loading`)
      }
    },
  },
}
</script>

<style>
.colorBoxH {
  padding: 5px;
  border-radius: 6px;
  color: rgb(112, 101, 236);
  background: rgba(112, 101, 236, 0.25);
}
.card-value {
  font-weight: bold;
}
</style>